import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from 'translations/en';
import de from 'translations/de';
import enNotificationsCentre from 'modules/notificationsCentre/translations/en';
import deNotificationsCentre from 'modules/notificationsCentre/translations/de';
import enShop from 'modules/shop/translations/en';
import deShop from 'modules/shop/translations/de';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    whitelist: ['en', 'de'],
    resources: {
      en: {
        translation: {
          ...en,
          ...enNotificationsCentre,
          ...enShop,
        },
      },
      de: {
        translation: {
          ...de,
          ...deNotificationsCentre,
          ...deShop,
        },
      },
    },
    fallbackLng: 'en',
    nsSeparator: ';;', // Single ';' is used in alerts
    debug: false,
  });

export default i18n;
